import { Observable } from "rxjs/Observable";
import * as actions from "./lookup.actions";
import { Lookup } from "./lookup.model";
import { RestrictedAccountObjectStoreFacade } from "../restricted-account-object/restricted-account-object.store-facade";
import { LookupType } from "../lookup-type/lookup-type.model";
import { ActionOptionsArgs } from "../../../core/store/actions/base-actions";
import { Qry } from "../query-facade";

export class LookupStoreFacade extends RestrictedAccountObjectStoreFacade<Lookup> {

    getAll(): Observable<Array<Lookup>> {
        return this.select(Qry.getInstance().lookup.byActiveAccount);
    }

    getFiltered(): Observable<Array<Lookup>> {
        return this.select(Qry.getInstance().lookup.filtered);
    }

    create(lookup: Lookup): void {
        this.dispatch(new actions.SubmitAction(lookup));
    }

    remove(lookup: Lookup, options?: ActionOptionsArgs): void {
        this.dispatch(new actions.RemoveAction(lookup, options));
    }

    update(lookup: Lookup): void {
        this.dispatch(new actions.SubmitAction(lookup));
    }

    insert(lookup: Lookup): void {
        this.dispatch(new actions.SubmitAction(lookup, {persistable: true, restful: false}));
    }

    removeByLookupType(lookupType: LookupType, options?: ActionOptionsArgs): void {
        this.removeBy(lookup => lookup.lookupType === lookupType.id, options);
    }

    setFilters(filters): void {
        this.dispatch(new actions.SetFilterAction(filters));
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/lookup/lookup.store-facade.ts